module.exports = __webpack_public_path__ + "static/TACO2-d6d32344aef80ffa2827e5969310a493.jpg";